import { Link } from "react-router-dom";
function NotFound() {
  return (
    <div className="base-text-container text-center">
      <h1 className="base-title">Pagina non trovata</h1>

      <p className="mt-4">La pagina che stai cercando non esiste.</p>

      <Link to="/" className="base-link">
        Torna alla home
      </Link>
    </div>
  );
}

export default NotFound;
